import {
  IAddressResource
} from 'modules/common/address/address.types';

export const ADDRESS_BLANK: IAddressResource = {
  addressType: 'REGISTRATION',
  country: null,
  entityId: null
}